import React from 'react';

const NotificationsContext = React.createContext(null);

export const NotificationsProvider = NotificationsContext.Provider;

export default NotificationsContext;